import IconArrowDown from 'assets/Icons/Arrow/Icon_arrow_down';
import DropdownButton from 'components/Buttons/DropdownButton';
import SearchFilterDropdownNotPeriod from 'components/Dropdown/SearchFilterDropdownNotPeriod';
import SearchInput from 'components/Input/SearchInput';
import { consultationListPageText, diagnosisListPageText, manageFilterList, searchFilterList } from 'constants/diagnosisListPageConstants';
import { TodayDiagnosisFilterProps } from 'models/Hospital/diagnosisListPageTypes';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { DropdownIconWrapper, ResetIconWrapper } from 'styles/Input/inputStyle';
import RefreshIcon from 'assets/Icons/Common/RefreshIcon';
import IconArrowUp from 'assets/Icons/Arrow/Icon_arrow_up';
import { adminManageFilterList } from 'constants/Admin/AdminManageUserJoinPageConstants';
import { adminManageHospitalFilterList } from 'constants/Admin/AdminManageHospitalPageConstants';
import { isConsultationHospital } from 'utils/hospitalUtils';
import { useLoginStore } from 'store/useLoginDataStore';
import { adminAssessmentPaymentSearchFilterList, CLManagingPatientSearchFilterList, CLUserLookupSearchFilterList } from 'pages/Admin/CL/constants';
import { Body1Bold, Body2Bold, Body3Bold, Body3Regular } from 'styles/Global/typography';

const TodayDiagnosisFilter = ({
    diagnosisNumber,
    selectedSearchFilter,
    handleDropdown,
    isSearchFilterDropdown,
    setIsSearchFilterDropdown,
    onChange,
    searchValue,
    handleSearchFilter,
    type,
}: TodayDiagnosisFilterProps) => {
    const dropdownRef = useRef<HTMLButtonElement>(null);

    const { loginData } = useLoginStore();

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && isSearchFilterDropdown) {
                setIsSearchFilterDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isSearchFilterDropdown]);

    const divideDropdown = (type?: string) => {
        switch (type) {
            case 'adminManageHospitalPage':
                return adminManageHospitalFilterList[selectedSearchFilter];
            case 'adminManageUserJoinPage':
                return adminManageFilterList[selectedSearchFilter];
            case 'managingPatients':
            case 'mindupTodayDiagnosis':
                return manageFilterList[selectedSearchFilter];
            case 'clManagingPatients':
                return CLManagingPatientSearchFilterList[selectedSearchFilter];
            case 'clUserLookup':
                return CLUserLookupSearchFilterList[selectedSearchFilter];
            case 'adminAssessmentPaymentPage':
                return adminAssessmentPaymentSearchFilterList[selectedSearchFilter];
            default:
                return searchFilterList[selectedSearchFilter];
        }
    };

    return (
        <>
            {/* TODO. 타입별 텍스트 리팩토링 필요 20250714-hmkong */}
            <CountTextWrapper>
                <Body1Bold>전체</Body1Bold>
                <Body3Regular>
                    {(diagnosisNumber || 0) +
                        (isConsultationHospital(loginData.hospitalId)
                            ? consultationListPageText.countDiagnosis
                            : type === 'clUserLookup'
                            ? diagnosisListPageText.userCount
                            : type === 'clManagingPatients'
                            ? diagnosisListPageText.userCount
                            : diagnosisListPageText.countDiagnosis)}
                </Body3Regular>
            </CountTextWrapper>
            <FilterButtonWrapper>
                <DropdownButton onClick={setIsSearchFilterDropdown} ref={dropdownRef}>
                    {/* {type ? managingPatientsFilterList[selectedSearchFilter] : searchFilterList[selectedSearchFilter]} */}
                    {divideDropdown(type)}
                    <DropdownIconWrapper>
                        {isSearchFilterDropdown ? (
                            <>
                                <IconArrowUp />
                                <SearchFilterDropdownNotPeriod type={type} selectedSearchFilter={selectedSearchFilter} handleDropdown={handleDropdown} />
                            </>
                        ) : (
                            <IconArrowDown />
                        )}
                    </DropdownIconWrapper>
                </DropdownButton>
                <SearchInputWrapper>
                    <SearchInput onChange={onChange} searchValue={searchValue} handleSearchFilter={handleSearchFilter} />
                </SearchInputWrapper>
                <ResetIconWrapper onClick={() => window.location.reload()}>
                    <RefreshIcon />
                </ResetIconWrapper>
            </FilterButtonWrapper>
        </>
    );
};

export default TodayDiagnosisFilter;

const FilterButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 100%;
`;

const SearchInputWrapper = styled.div`
    position: relative;
    width: 220px;
    height: 100%;
    border-radius: 4px;
`;

const CountTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;
